import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NotificationApiModel} from '@npck/af-frontend-api';
import {StatusStyle} from '../../../../components/status/status.component';

@Component({
    selector: 'af-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrl: './notification-item.component.scss',
    standalone: false
})
export class NotificationItemComponent implements OnInit {
    @ViewChild('container') container: ElementRef<HTMLDivElement>;
    @Input() notification: NotificationApiModel;
    @Input() highlightNew = true;
    StatusStyle = StatusStyle;
    idTranslationKeys: FieldTranslation[] = [
        {
            context: 'incident',
            translationKey: 'i18n_af_notification_summary_template_key_id_incident',
        },
        {
            context: 'inquiry',
            translationKey: 'i18n_af_notification_summary_template_key_id_incident',
        },
        {
            context: 'subject',
            translationKey: 'i18n_af_notification_summary_template_key_id_subject',
        },
        {
            context: 'fraud',
            translationKey: 'i18n_af_notification_summary_template_key_id_subject',
        },
        {
            context: 'suspect',
            translationKey: 'i18n_af_notification_summary_template_key_id_subject',
        },
        {
            context: 'fraudster',
            translationKey: 'i18n_af_notification_summary_template_key_id_subject',
        },
        {
            context: 'refund',
            translationKey: 'i18n_af_notification_summary_template_key_id_refund',
        },
    ];
    statusTranslationKeys: FieldTranslation[] = [
        {
            context: 'incident_create',
            translationKey: 'i18n_af_notification_summary_template_key_status_incident',
        },
        {
            context: 'incident_update',
            translationKey: 'i18n_af_notification_summary_template_key_status_incident',
        },
        {
            context: 'incident_delete',
            translationKey: 'i18n_af_notification_summary_template_key_status_incident',
        },
        {
            context: 'refund',
            translationKey: 'i18n_af_notification_summary_template_key_status_refund'
        }
    ];

    parsedSummary: ParsedSummary;
    idTranslationKey: string;
    statusTranslationKey?: string;
    isNew: boolean;

    ngOnInit(): void {
        this.isNew = this.notification.status === 'not viewed';
        this.idTranslationKey = this.idTranslationKeys
            .find(item => this.notification.type.startsWith(item.context)).translationKey;
        this.statusTranslationKey = this.statusTranslationKeys
            .find(item => this.notification.type.startsWith(item.context))?.translationKey;
        this.parsedSummary = this.parseSummary(this.notification.content?.summary);
    }

    parseSummary(summary: string): ParsedSummary {
        const lines = summary.split('\n');
        let parsedSummary: ParsedSummary = {};

        for (const line of lines) {
            const parts = line.split(': ');
            if (parts.length < 2) {
                continue;
            }

            const key = parts[0].trim();
            const value = parts.slice(1).join(': ').trim();

            switch (key) {
                case 'Тема':
                    parsedSummary = {
                        ...parsedSummary,
                        topic: value,
                    };
                    break;
                case 'Дата':
                    parsedSummary = {
                        ...parsedSummary,
                        date: value,
                    };
                    break;
                case 'ID возврата':
                case 'ID субъекта':
                case 'к инциденту':
                case 'ID записи в списке':
                case 'ID':
                    parsedSummary = {
                        ...parsedSummary,
                        id: value,
                    };
                    break;
                case 'ID инцидента':
                    parsedSummary = parsedSummary.id
                        ? {...parsedSummary, parentId: value}
                        : {...parsedSummary, id: value};
                    break;
                case 'Статус инцидента':
                case 'Статус возврата':
                    parsedSummary = {
                        ...parsedSummary,
                        status: value,
                    };
                    break;
                case 'Категория':
                    parsedSummary = {
                        ...parsedSummary,
                        category: value
                    };
                    break;
                case 'Сообщение':
                    parsedSummary = {
                        ...parsedSummary,
                        message: value,
                    };
                    break;
                default:
                    break;
            }
        }

        return parsedSummary;
    }
}

interface FieldTranslation {
    context: string;
    translationKey: string;
}

interface ParsedSummary {
    topic?: string;
    date?: string;
    id?: string;
    parentId?: string;
    status?: string;
    category?: string;
    message?: string;
}
